import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function LiveViews({ pageId }) {
  const [count, setCount] = useState(0);

  const admin = useSelector((state) => state.user.admin);

   const apiSocketUrl = process.env.REACT_APP_API_SOCKET_URL;

  useEffect(() => {
    const ws = new WebSocket(`ws://${apiSocketUrl}`);
    // const ws = new WebSocket("ws://192.168.0.194:2323");

    ws.onopen = () => {
      ws.send(JSON.stringify({ pageId }));
    };

    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data.pageId === pageId) setCount(data.count);
    };

    return () => ws.close();
  }, [pageId]);

  // if (pageId === 'Blackbaton') {
  //   return <p>{count} people are viewing this page now</p>
  // }

  if (admin !== '1') return null

  return <p className="text-[.75rem] font-dmSans">{count > 0 ? count : ''}
  </p>;
}

export default LiveViews;
